import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DatePickerComponent} from './date-picker.component';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {FormsModule} from '@angular/forms';
import {LocaleService} from '../../../configurations/locale/locale-service';

@NgModule({
	declarations: [DatePickerComponent],
	imports: [
		CommonModule,
		BsDatepickerModule.forRoot(),
		FormsModule
	],
	exports: [
		DatePickerComponent
	],
	providers: [LocaleService]
})
export class DatePickerModule {
}
